<template>
  <div class="homePage">
    <img class="homePage_bg" src="../static/images/homePage/home_bg.png" alt="" />
    <div class="video_content_title">
      <div class="content_title_l">冠军榜</div>
      <div class="content_title_r">
        <img src="../static/images/homePage/icon_paihang.gif" />
        <span>最火爆的剧</span>
      </div>
    </div>
    <div class="s1_list">
      <template v-for="(item, index) in championList">
        <div :key="index" class="s1_item" @click="goPlayerDetail(item)">
          <img
            class="item_mark"
            :src="`https://fruitsoss.yunyihudong.com/shortPlay/images/h5/bd_top${index + 1}.png`"
          />
          <img class="item_img" :src="item.cover_url" />
          <div class="item_title ellipsis_line1">{{ item.name }}</div>
        </div>
      </template>
    </div>
    <div class="video_content_title video_content_title2">
      <div class="content_title_l">热门</div>
      <div class="content_title_r" style="background-color: #f6f6f6">
        <img src="../static/images/homePage/icon_huojian.gif" />
        <span>本周热门剧</span>
      </div>
    </div>
    <div class="video_box">
      <div
        class="video_item"
        v-for="(item, index) in videoList"
        :key="index"
        @click="goPlayerDetail(item)"
      >
        <img class="video_cover" :src="item.cover_url" alt="" />
        <div class="video_name">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getCategoryVideoList } from '../apis/video'
export default {
  data() {
    return {
      championList: [],
      videoList: [],
      videoPageObj: {
        page: 1,
        page_size: 30
      }
    }
  },
  computed: {
    ...mapGetters(['referer', 'currentPage', 'appInit'])
  },
  async created() {
    if (!this.appInit) {
      await this.$store.dispatch('common/initSDK')
    }
    this.getList()
    REPORT_SDK.report({
      event_id: 'theatre_page_show',
      event_name: '剧场-剧场首页',
      referer: this.referer
    })
  },
  methods: {
    getList() {
      getCategoryVideoList({ filter_copyright_category: [1, 2], ...this.videoPageObj }).then(
        (res) => {
          console.log(res)
          res.forEach((item, index) => {
            if (index < 3) {
              this.championList.push(item)
            } else {
              this.videoList.push(item)
            }
          })
        }
      )
    },
    goPlayerDetail(item) {
      REPORT_SDK.report({
        event_id: 'theatre_page_click',
        event_name: '剧场-剧场首页点击',
        referer: this.referer,
        element_name: '剧目'
      })
      this.$router.push(`/PlayerDetail?video_id=${item.id}`)
    }
  }
}
</script>

<style lang="less" scoped>
.homePage {
  width: 100vw;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  box-sizing: border-box;
  .homePage_bg {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 750px;
    height: 470px;
    z-index: 0;
  }
  .video_content_title {
    display: flex;
    justify-content: space-between;
    z-index: 2;
    .content_title_l {
      font-size: 32px;
      font-weight: 600;
      color: #000;
    }
    .content_title_r {
      border-radius: 200px;
      height: 44px;
      background-color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 14px;
      img {
        width: 54px;
        height: 54px;
      }
      span {
        font-size: 22px;
        color: #666;
      }
    }
  }
  .video_content_title2 {
    margin-bottom: 28px;
    margin-top: 40px;
  }
  .s1_list {
    position: relative;
    display: flex;
    justify-content: space-between;
    height: 309px;
    z-index: 2;
    align-items: flex-end;
    margin-top: 28px;
    .s1_item {
      position: relative;
      width: 204px;
      height: 272px;
      .item_mark {
        position: absolute;
        top: -4px;
        left: 0;
        width: 66px;
        height: 30px;
      }
      .item_img {
        width: 100%;
        height: 100%;
        border-radius: 8px;
      }
      .item_title {
        position: absolute;
        padding: 0 10px;
        box-sizing: border-box;
        opacity: 0.9;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 48px;
        font-weight: 600;
        line-height: 48px;
        text-align: center;
        font-size: 26px;
        color: #fff;
        border-radius: 0 0 8px 8px;
      }
    }
    .s1_item:nth-child(1) {
      position: absolute;
      left: 228px;
      bottom: 0;
      width: 232px;
      height: 309px;
      .item_title {
        background: linear-gradient(180deg, #a6835f 0%, #735e46 100%);
      }
      .item_mark {
        width: 74px;
        height: 34px;
      }
    }
    .s1_item:nth-child(2) {
      .item_title {
        background: linear-gradient(180deg, #77808f 0%, #444c53 100%);
      }
    }
    .s1_item:nth-child(3) {
      .item_title {
        background: linear-gradient(180deg, #6f5945 0%, #4c4036 100%);
      }
    }
  }
  .video_box {
    width: 690px;
    display: flex;
    flex-wrap: wrap;
    .video_item {
      width: 218px;
      margin-bottom: 24px;
      margin-right: 18px;
      .video_cover {
        width: 218px;
        height: 291px;
        border-radius: 8px;
        margin-bottom: 14px;
      }
      .video_name {
        width: 100%;
        height: 36px;
        overflow: hidden;
        -webkit-line-clamp: 1;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        white-space: normal; // 规定段落中的文本不进行换行
        word-break: break-all; // 允许单词中换行，在容器的最右边进行断开不会浪费控件
        word-wrap: break-word; // 防止长单词溢出，单词内部短句
        font-size: 26px;
        color: #333333;
        font-weight: 600;
        line-height: 36px;
        text-align: left;
      }
    }
    .video_item:nth-child(3n) {
      margin-right: 0px;
    }
  }
}
</style>
